<template>
    <v-container fluid px-0>
        <v-layout row>
            <v-flex xs12 class="common-card">
                <v-flex class="star">
                    <v-icon color="#3E67FB" size="28">assignment</v-icon>
                    <span class="ml-3 font-weight-bold blue-title title">Speaking Test （CEFR）</span>
                    <v-btn class="text-none ml-5 blue-button" :style="{'background':submitColor}" @click="openAchievement">Assessment Completed</v-btn>
                </v-flex>
            </v-flex>
        </v-layout>
        <v-dialog  v-model="achievement.dialog" max-width="782px">
            <v-form ref="form">
                <v-card>
                <v-card-title class="title blue-title pa-3 pt-4 ml-2">
                    Assess Achievement
                    <div class="header-close" title="close" @click="achievement.dialog = false">
                    <v-icon>close</v-icon>
                    </div>
                </v-card-title>
                <v-divider></v-divider>

                <v-card-text>
                    <v-form ref="form" v-model="valid" lazy-validation>
                    <v-layout row wrap px-2>
                        <v-flex xs12 v-for="(item,i) in subjectList" :key="i" class="mb-4">
                            <p class="blue-title" style="font-size: 15px;"><span class="title">{{i+1}}.</span>&#8195;<span v-html="newStr(item.title)"></span></p>
                            <div class="mb-4" v-for="(value,index) in JSON.parse(item.smalls)" :key="'ind_'+index">
                                <p class="blue-title">{{index+1}}. {{value.SDes}}</p>
                                <template v-if="value.options && value.options.length && value.options[0]!==null && value.options[0]!=='null' && (item.type==1 || item.type==2 || item.type==5 || item.type==7)">
                                    <v-layout row wrap class="mb-3">
                                        <v-flex v-for="(v,n) in value.options" :key="'index_'+n" class="blue-title">
                                            {{scoreOptions[n]}}. <img v-if="item.type==1 || item.type==2" :src="'https://admin.acadsoc.com.cn/'+v" alt="" width="200px">
                                                                <span v-else>{{v}}</span>
                                        </v-flex>
                                    </v-layout>
                                </template>
                            </div>
                            <div class="mb-3">
                                <v-select :items="totalScore(item.smalls)"
                                        v-model="form['score_'+i]"
                                        ref="selectS"
                                        outline
                                        single-line
                                        required
                                        :rules="rules"
                                        label="Please Choose">
                                </v-select>
                            </div>
                        </v-flex>
                        
                    </v-layout>
                    
                    <v-layout row>
                        <v-flex xs12 class="text-xs-center mt-3">
                        <v-btn
                            class="text-none red-button dialog-submit"
                            @click="submitAchievement"
                            :loading="loading"
                            >Submit</v-btn>
                        </v-flex>
                    </v-layout>
                    </v-form>
                </v-card-text>
                </v-card>
            </v-form>
        </v-dialog>
    </v-container>
    
</template>
<script>
import { createNamespacedHelpers } from 'vuex'
const namespace = 'classDetail'
const { mapGetters } = createNamespacedHelpers(namespace)
import {  getMasterSpokenDetailsByCLID, submitMasterRecordByCLID } from '../../api/classtable'
export default {
    data:()=>({
        achievement:{
            dialog:false
        },
        subjectList:[],
        submitColor:"#3E67FB",
        loading:false,
        scoreOptions:["A","B","C","D","E","F"],
        valid:true,
        form:{},
        rules:[v => !!v || 'Required']
    }),
    computed: {
        ...mapGetters(['info'])
    },
    mounted(){
        getMasterSpokenDetailsByCLID(this.info.CLID).then(res=>{
            if(res&&res.titles){
                this.subjectList = res.titles
                var answer = JSON.parse(res.record)[1]
                if(answer && answer.length){
                    answer.forEach((v,i)=>{
                        this.form['score_'+i] = String(v)
                    })
                    this.submitColor='#EE344C !important'
                }
            }
        })
    },
    methods:{
        openAchievement(){
            if(!this.info.IsOverClass){
                this.$root
                .$confirm(
                `Please fill in 25 minutes after the start of the course`,
                'default',
                { 
                    width:470,
                    confirmBtn:{
                        display:true
                    },  
                    cancelBtn:{
                        display:false
                    },
                })
                return
            }
            this.achievement.dialog = true
        },
        totalScore(list){
            var _list  = JSON.parse(list);
            var score = 0;
            var options = [];
            _list.forEach(function(v,i){
                score+=parseInt(v.Score)
            })
            if(score==1){
                options = [
                    { text: "Does not meet the standard", value: "0" }, { text: "Fully meets the standard", value: "1" }
                ]
            }else if(score==2){
                options = [
                    { text: "Does not meet the standard", value: "0" }, { text: "Partially meets the standard", value: "1" }, { text: "Fully meets the standard", value: "2" }
                ]
            }else if(score==5){
                options = [
                    { text: "Does not meet the standard", value: "0" }, { text: "Insufficiently meets the standard", value: "1" }, { text: "A few meets the standard", value: "2" }, { text: "Partially meets the standard", value: "3" }, { text: "Mostly meets the standard", value: "4" }, { text: "Fully meets the standard", value: "5" }
                ]
            }
            return options;
        },
        submitAchievement(){
            if((!this.valid && this.$refs.form.validate()) || Object.keys(this.form).length<this.subjectList.length){
                console.log('form-error');
                this.$refs.selectS.forEach((v,i)=>{
                    if(!v.value){
                        v.focus();
                        v.value=0
                    }
                })
                return
            }
            var list = [];
            this.subjectList.forEach((v,i)=>{
                list.push(parseInt(this.form['score_'+i]))
            })
             submitMasterRecordByCLID({clid:this.info.CLID,jsonStr:JSON.stringify(list)}).then(res=>{
                 if(res==1){
                     this.$root.$alertTips('Success!','success').then(()=>{
                         this.achievement.dialog = false
                     })
                 }
            })
            
        },
        newStr(str){
            var newContent = str.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/gi,function(match,capture){
                //capture,返回每个匹配的字符串
                var newStr='<img src="https://admin.acadsoc.com.cn/'+capture+'" alt="" width="200px"/>';
                return newStr;
            });
            return newContent
        }
    }
}
</script>
<style lang="scss" scoped>
    .star{
        .v-icon,span{
            vertical-align: middle;
        }
        .v-btn{
            height:28px
        }
    }
</style>